import { Tooltip } from '@/components/Atoms/Tooltip/Tooltip';
import classNames from '@/utils/classNames';
import type { ReactNode } from 'react';
import { useId } from 'react';
import type { FCC } from 'react-fc';
import styles from './FormField.module.css';

export const FormField: FCC<{
    label: ReactNode;
    help?: string;
    asGroup?: boolean;
    asFieldset?: boolean;
    inline?: boolean;
}> = ({ children, className, label, asGroup, asFieldset, help, inline }) => {
    const flyoutId = useId();

    const fieldsetProps = {
        className: classNames(className, styles.fieldset, { [styles.inline]: inline }),
    };

    const legendProps = {
        className: classNames(
            styles.legend,
            { ['cds-t-group-heading2']: asFieldset },
            { ['cds-t-label']: !asFieldset }
        ),
        'aria-describedby': help ? flyoutId : undefined,
        children: (
            <>
                {label}
                {help && <Tooltip id={flyoutId}>{help}</Tooltip>}
            </>
        ),
    };

    if (asGroup) {
        return (
            <fieldset {...fieldsetProps}>
                <legend {...legendProps} />
                {children}
            </fieldset>
        );
    }
    return (
        <label {...fieldsetProps}>
            <span {...legendProps} />
            {children}
        </label>
    );
};
